var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"iconized"},[_c('i',{staticClass:"icon material-icons"},[_vm._v(_vm._s(_vm.icon))]),_c('div',{staticClass:"label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }